module.exports = __webpack_public_path__ + "img/classique.01c81aeb.jpg";